/** This export is automatically generated */
export const gitHash = 'ac3c679c2';
